import React from 'react';
import { Sun, Wind, Droplets } from 'lucide-react';
export function WeatherWidget() {
  return <div className="absolute top-4 right-4 z-20 float-card px-4 py-3" data-id="element-113">
      <div className="flex items-center space-x-4" data-id="element-114">
        <div className="flex items-center space-x-2" data-id="element-115">
          <Sun className="w-5 h-5 text-amber-500" data-id="element-116" />
          <span className="text-lg font-semibold text-[var(--text-primary)]" data-id="element-117">
            62°
          </span>
        </div>
        <div className="h-8 w-px bg-[var(--border)]" data-id="element-118"></div>
        <div className="flex items-center space-x-3 text-xs text-[var(--text-secondary)]" data-id="element-119">
          <div className="flex items-center space-x-1" data-id="element-120">
            <Wind className="w-3.5 h-3.5" data-id="element-121" />
            <span data-id="element-122">8 mph</span>
          </div>
          <div className="flex items-center space-x-1" data-id="element-123">
            <Droplets className="w-3.5 h-3.5" data-id="element-124" />
            <span data-id="element-125">12%</span>
          </div>
        </div>
      </div>
    </div>;
}